module.exports = {
  contractAddress: "0x3F2AeE683a49EbD635707B18Ed3240cc24A53530",
  // 1 => Ethereum, 4=> Rinkeby, 137 => Polygon, 80001 => Mumbai
  requiredChainId: 1,
  networkName: "Ethereum Mainnet"

}